import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import BuildingSelection from "./pages/BuildingSelection";
import ReservationPageA from "./pages/ReservationPageA";
import ReservationPageB from "./pages/ReservationPageB";
import ReservationPageC from "./pages/ReservationPageC";
import MyReservationsPage from "./pages/MyReservationsPage";
import AdminReservationsPage from "./pages/AdminReservationsPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import ContactPage from "./pages/ContactPage";
import AdminUploadPage from "./pages/AdminUploadPage";
import RequestApprovalPage from "./pages/RequestApprovalPage";
import ApprovalPage from "./pages/ApprovalPage";
import ApprovalsListPage from "./pages/ApprovalsListPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/buildings" element={<BuildingSelection />} />
      <Route path="/reservations/buildingA" element={<ReservationPageA />} />
      <Route path="/reservations/buildingB" element={<ReservationPageB />} />
      <Route path="/reservations/buildingC" element={<ReservationPageC />} />
      <Route path="/my-reservations" element={<MyReservationsPage />} />
      <Route path="/admin-reservations" element={<AdminReservationsPage />} />
      <Route path="/terms-of-use" element={<TermsOfUsePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/admin-upload" element={<AdminUploadPage />} />
      <Route path="/request-approval" element={<RequestApprovalPage />} />
      <Route path="/approvals/:id" element={<ApprovalPage />} />
      <Route path="/approvals" element={<ApprovalsListPage />} />
    </Routes>
  );
}

export default App;
